import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Search, Close } from '@mui/icons-material';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { FC } from 'react';
import { FiltersButtons, FiltersLayout } from '../../../../components';

interface IManageModelHomeFurnitureFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setPage: (val: number) => void;
  setHasAppliedFilters: (val: boolean) => void;
  hasAppliedFilters?: boolean;
  searchName: string;
  setSearchName: (val: any) => void;
  handleNameSearch: (clearSearch?: boolean) => void;
}

export const ManageModelHomeFurnitureFilters: FC<IManageModelHomeFurnitureFilters> = ({
  hasAppliedFilters,
  setHasAppliedFilters,
  isLoading,
  applyFilters,
  searchName,
  setSearchName,
  handleNameSearch
}) => {
  const classes = useStyles();

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          placeholder="Search..."
          name="nameSearch"
          value={searchName}
          disabled={isLoading}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.searchIcon}
                onClick={() => {
                  if (searchName.length > 0) {
                    setHasAppliedFilters(true);
                    handleNameSearch();
                  }
                }}
              >
                <Search />
              </InputAdornment>
            ),
            endAdornment: searchName ? (
              <InputAdornment
                position="end"
                className={classes.searchIcon}
                onClick={() => {
                  setHasAppliedFilters(false);
                  setSearchName('');
                  handleNameSearch(true);
                  applyFilters(true);
                }}
              >
                <Close />
              </InputAdornment>
            ) : null
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && searchName.length > 0) {
              setHasAppliedFilters(true);
              handleNameSearch();
            }
          }}
          onChange={e => {
            setSearchName(e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            handleNameSearch();
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearchName('');
            handleNameSearch(true);
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  }
}));
